import type { Signal } from '@angular/core'
import { Injectable, signal } from '@angular/core'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'
import { CustomFieldDefinition } from '@awork/features/project/models/custom-field-definition.model'

@Injectable({ providedIn: 'root' })
export class CustomFieldDefinitionStore extends EntitySignalStore<CustomFieldDefinition> {
  private readonly hasLoadedAllDefinitions = signal(false)

  constructor() {
    super({
      name: 'customFieldDefinition',
      entityConstructor: customFieldDefinition => new CustomFieldDefinition(customFieldDefinition)
    })
  }

  /**
   * Gets whether the complete custom field definition list has loaded.
   * @returns {Signal<boolean>}
   */
  getHasLoadedAllDefinitions(): Signal<boolean> {
    return this.hasLoadedAllDefinitions
  }

  /**
   * Marks the complete custom field definition list as loaded.
   */
  markAllDefinitionsLoaded(): void {
    this.hasLoadedAllDefinitions.set(true)
  }

  /**
   * Resets the custom field definition store and full-list loaded marker.
   * @param {string} action
   */
  override reset(action?: string): void {
    super.reset(action)
    this.hasLoadedAllDefinitions.set(false)
  }
}
